<template>
  <div class="page-wrapper-table">
    <div class="page-wrapper-table-header">
      <el-select
        class="select-primary pagination-select"
        v-model="pagination.perPage"
        :placeholder="$t('COMMON.PER_PAGE')"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <!--<contact-selector
        v-if="
          !filterContact &&
          $currentUserCan($permissions.PERM_VIEW_ANY_CONTACTS)
        "
        @contactChanged="
          (contactId) => (selectedContact = contactId)
        "
      />-->
      <el-select
        :clearable="true"
        class="select-primary pagination-select"
        v-model="communicationType"
        min-width="220"
        :placeholder="$t('COMMUNICATIONS.COMMUNICATION_TYPE')"
      >
        <el-option
          class="select-primary"
          :label="$t(`COMMON.ALL`)"
          :value="null"
        >
        </el-option>
        <el-option
          v-for="item in COMMUNICATIONS_TYPES"
          class="select-primary"
          :label="$t(`COMMUNICATIONS.COMMUNICATIONS_TYPE_${item}`)"
          :value="item"
          :key="item"
        >
        </el-option>
      </el-select>
      <property-selector
        v-if="
          !filterProperty &&
          $currentUserCan($permissions.PERM_VIEW_ANY_PROPERTIES)
        "
        @propertyChanged="
          (property) => (selectedProperty = property.id)
        "
      />
      <base-input class="dates" placeholder="Dates">
          <flat-picker
            :config="{
              allowInput: true,
              mode: 'range',
              locale: flatPickrLocale,
            }"
            class="form-control datepicker"
            v-model="dateRange"
            placeholder="Dates"
          >
          </flat-picker>
        </base-input>
      <base-input
        v-model="tracking_number"
        type="search"
        :placeholder="$t('COMMUNICATIONS.TRAKING_NUMBER')"
        clearable
      />
      <base-input
        v-model="query"
        type="search"
        prepend-icon="fas fa-search"
        :placeholder="$t('COMMON.SEARCH')"
        clearable
      />
    </div>
    <div class="page-wrapper-table-body">
      <div class="page-wrapper-table-body-inner">
        <el-table
          class="align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="communications"
          @sort-change="sortChange"
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>
          <el-table-column :label="$t('COMMUNICATIONS.COMMUNICATION_TYPE')" min-width="220" sortable="custom">
            <template v-slot="{ row }">
              {{ $t(`COMMUNICATIONS.COMMUNICATIONS_TYPE_${row.communication_type}`) }}
            </template>
          </el-table-column>el-table-column/>
          <el-table-column
              :label="$t('COMMUNICATIONS.DATE')"
              prop="date"
              sortable="custom"
              min-width="220"
            >
              <template v-slot="{ row }">
                {{ $formatDate(row.date) }}
              </template>
            </el-table-column>
          <el-table-column
            :label="$t('COMMUNICATIONS.TRAKING_NUMBER')"
            prop="tracking_number"
            sortable="custom"
            min-width="220"
          />
          <el-table-column
            :label="$t('COMMON.CONTACTS')"
            sortable="custom"
            min-width="220"
            v-if="
              !filterContact &&
              $currentUserCan($permissions.PERM_VIEW_ANY_CONTACTS)
            "
          >
            <template v-slot="{ row }">
              <contact :contact="row.contact" />
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('COMMON.ATTACHEMENTS')"
            sortable="custom"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{row.attachements ? row.attachements.length : '-' }}
            </template>
          </el-table-column>
          <el-table-column
              :label="$t('COMMON.CREATED_AT')"
              prop="created_at"
              sortable="custom"
              min-width="220"
            >
              <template v-slot="{ row }">
                {{ $formatDate(row.created_at) }}
              </template>
            </el-table-column>
          <el-table-column fixed="right" min-width="120">
            <div slot-scope="{ row }" class="table-actions">
              <el-tooltip
                :content="$t('COMMON.VIEW')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_VIEW_COMMUNICATIONS)"
              >
                <a
                  type="text"
                  @click="viewCommunication(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-expand-alt"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                :content="$t('COMMON.EDIT')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_EDIT_COMMUNICATIONS)"
              >
                <a
                  type="text"
                  @click="editCommunication(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-edit"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                content="Delete"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_DELETE_COMMUNICATIONS)"
              >
                <a
                  type="text"
                  @click="deleteCommunication(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-trash-alt"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-wrapper-table-footer">
      <p class="card-category">
        {{
          $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
            from: total ? from + 1 : 0,
            to: to,
            of: total,
          })
        }}

        <span v-if="selectedRows.length">
          &nbsp; &nbsp;
          {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
        </span>
      </p>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { French } from "flatpickr/dist/l10n/fr.js";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import ContactSelector from "@/components/ContactSelector.vue";
import PropertySelector from "@/components/PropertySelector.vue";
import Contact from "@/components/Contact.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { COMMUNICATIONS_TYPES } from "@/constants/communications";

export default {
  name: "communication-list-table",

  components: {
    BasePagination,
    //ContactSelector,
    PropertySelector,
    Contact,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "organization id",
    },
    filterContact: {
      type: String,
      default: null,
      description: "contact id",
    },
    filterProperty: {
      type: String,
      default: null,
      description: "property id",
    },
  },

  data() {
    return {
      flatPickrLocale: French,
      query: null,
      tracking_number:null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      COMMUNICATIONS_TYPES,
      communicationType:null,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      communications: [],
      loading: true,
      dateRange: null,
      selectedOrganization: null,
      selectedContact: null,
      selectedProperty: null,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    tracking_number: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    communicationType: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterContact: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedContact: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedProperty: {
      handler: "getListDebounced",
      immediate: true,
    },
    dateRange: {
      handler: "getListDebounced",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        this.loading = true;
        const vDateRange = this.dateRange
          ? this.dateRange.split(this.flatPickrLocale.rangeSeparator)
          : [];
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
          ...(this.query ? { code: this.query } : {}),
          ...(this.tracking_number ? { tracking_number: this.tracking_number } : {}),
            ...(vDateRange.length == 2
              ? {
                  date: [
                    vDateRange[0] + " 00:00:00",
                    vDateRange[1] + " 23:59:59",
                  ],
                }
              : {}),
        },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization,contact,properties",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }
        if (this.communicationType) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              communication_type: this.communicationType,
            },
          };
        }
        if (this.selectedProperty) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              property: this.selectedProperty,
            },
          };
        }

        await this.$store.dispatch("communications/list", params);
        this.communications = this.$store.getters["communications/list"];
        console.log(this.communications);
        this.total = this.$store.getters["communications/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    deleteCommunication(communication) {
      this.$emit("onDeleteCommunication", communication);
    },

    viewCommunication(communication) {
      this.$emit("onViewCommunication", communication);
    },

    editCommunication(communication) {
      this.$emit("onEditCommunication", communication);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
